import { render } from "./Footer.vue?vue&type=template&id=1b7245a2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\RSMentari\\Project RSM\\Portal RSM\\frontend-rsm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__